<template>
    <div class="col-md-9">
        <h1 class="pages__title">Testimonial</h1>
        <div class="pages__box">
            <div class="form">
                <ValidationObserver ref="form">
                    <ValidationProvider
                        class="form-group mb-3"
                        name="Author Name"
                        v-slot="{ errors }"
                        rules="required"
                    >
                        <label for="" class="form-label">Author Name</label>
                        <input
                            type="text"
                            v-model="testimonial.author_name"
                            class="form-control pl-4"
                        >
                        <FormError :error="errors[0]" name="Author Name"></FormError>
                    </ValidationProvider>
                    <ValidationProvider
                        class="form-group mb-3"
                        name="Author Position"
                        v-slot="{ errors }"
                        rules="required"
                    >
                        <label for="" class="form-label">Author Position</label>
                        <input
                            type="text"
                            v-model="testimonial.author_position"
                            class="form-control pl-4"
                        >
                        <FormError :error="errors[0]" name="Author Position"></FormError>
                    </ValidationProvider>



                    <ValidationProvider
                        class="form-group mb-3"
                        name="Content"
                        v-slot="{ errors }"
                        rules="required"
                    >
                        <label for="" class="form-label">Content</label>
                        <textarea
                            type="text"
                            class="form-control pl-4"
                            v-model="testimonial.content"
                        ></textarea>
                        <FormError :error="errors[0]"  name="Content"></FormError>
                    </ValidationProvider>

                    <BaseButtons
                        :on-cancel="backToPreviousPage"
                        :on-save="validateForm"
                    />

                </ValidationObserver>
            </div>
        </div>
    </div>
</template>

<script>

import {defineComponent} from "vue";
import BaseButtons from "../../Common/BaseButtons.vue";
import FormError from "../../Common/FormError.vue";
import ModalHandler from "../../../mixins/ModalHandler";
import AdminPanelService from "../../../services/AdminPanelService";

export default defineComponent({
    name: 'TestimonialEditor',
    mixins: [ModalHandler],
    components: {FormError, BaseButtons},
    props: {
        testimonialId: Number
    },
    data() {
        return {
            testimonial: {
                content: null,
                author_name: null,
                author_position: null,
            },
        }
    },
    methods: {
        async getTestimonialInfo() {
            try {
                const { data : response} = await AdminPanelService.getTestimonial(this.testimonialId)
                this.testimonial = response
            } catch (error) {
                console.error(error)
            }
        },
        async validateForm() {
            this.$showLoadingMessage()
            const valid = await this.$refs.form.validate();

            if (!valid) {
                this.$showValidationErrorMessage();
                return;
            }

            if (this.testimonialId) {
                await this.updateTestimonialInfo()
            } else {
                await this.createTestimonial()
            }
        },

        async createTestimonial() {
            try {
                await AdminPanelService.createTestimonial(this.testimonial)
                this.$showSuccessMessage('The information was saved')
            } catch (e) {
                console.error(e)
            }
        },
        async updateTestimonialInfo() {
            try {
                await AdminPanelService.updateTestimonial(this.testimonialId, this.testimonial)
                this.$showSuccessMessage('The information was updated')
            } catch (e) {
                console.error(e)
            }
        }
    },
    mounted() {
        if( this.testimonialId) {
            this.getTestimonialInfo()
        }
    }
})
</script>



<style scoped>

</style>
